<mat-dialog-content>
  <div style="display: flex;">
    <table class="assortment_table" style="min-width:100%" mat-table [dataSource]="data">
      <ng-container matColumnDef="product">
        <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
         PRODUCTS ADDED
        </th>
        <td mat-cell *matCellDef="let data">
          {{ data.sku_face }}
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="shelf">
        <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
          SHELF
        </th>
        <td mat-cell *matCellDef="let data">
          {{ data.shelf }}
        </td>
      </ng-container> -->
      <ng-container matColumnDef="facings">
        <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
          FACINGS
        </th>
        <td mat-cell *matCellDef="let data">
          {{ data.final_facings }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
    <!-- <div><img style="height: 70vh" src="../../assets/12 Caser.png" /></div> -->
  </div>
</mat-dialog-content>
